type LogoIconProps = {
};

export const LogoIcon = ({ ...props }: LogoIconProps): JSX.Element => <img {...props} src="/~/assets/img/logo.png" alt="Logo" />;
